import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime, IUserFormParameters } from "../../FormRuntime";

import { FileDownloadFormControl } from "../Web/FileDownloadFormControl";

import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { XStackContainer } from "../../Containers";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

// todo: fix. this is the old template.  it should NOT require to listen to the data outside of the form to work.  FIX!
// const Template: StoryBook<IUserFormParameters> = (args) => (
//     <ObserveState listenTo={args} properties={["formData"]} control={() => <XUserForm {...args} />} />
// );

function getUI(): IUserFormParameters {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    let uploadField = new FileDownloadFormControl();
    uploadField.valueName = "upload";
    uploadField.label = "File Upload";

    container.add(uploadField);

    ui.add(container);

    const data = new ExecutionData();

    const result = {
        form: ui,
        onFormDataChange: (_: ExecutionData) => {
            StateManager.propertyChanged(result, "formData");
        },
        formData: data,
    };

    return result;
}

export const FileDownloadStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Download",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileDownloadFormControl).showFileSize = false;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Download",
        "Without File Name",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileDownloadFormControl).showFileSize = true;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Download",
        "With File Name",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileDownloadFormControl).showPreview = true;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Download",
        "With Preview",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileDownloadFormControl).showPreview = false;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Download",
        "Without Preview",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileDownloadFormControl).filesLimit = 1;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Download",
        "Single File",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileDownloadFormControl).filesLimit = 3;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Download",
        "Multiple File",
    ),
];
